import React, { Component } from "react";

import ButtonPrimary from "../../shared/items/contols/buttonPrimary";
import PreloaderLight from "./../../shared/items/static/preloaderLight";
import { states } from "./../../reducers/queriesStates";

import styles from "./buttonRegistrationWrapper.module.scss";
import { withRegistration } from "../../shared/containers/containerRegistration";

class ButtonRegistratonWrapper extends Component {
  componentDidMount() {
    document.addEventListener("keydown", this.clickEnter);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.clickEnter);
  }

  clickEnter = (e) => {
    const { onRegistration, registration } = this.props;

    if (e.keyCode === 13) {
      onRegistration(registration.registrationItems);
    }
  };

  onRegistration() {
    const { onRegistration, registration } = this.props;
    onRegistration(registration.registrationItems);
  }

  render() {
    const { registration } = this.props;

    return (
      <ButtonPrimary handleClick={this.onRegistration.bind(this)}>
        {registration.dataState === states.REQUEST ? (
          <div className={styles.container_preloader}>
            <PreloaderLight />
          </div>
        ) : (
          "Зарегистрироваться"
        )}
      </ButtonPrimary>
    );
  }
}

export default withRegistration(ButtonRegistratonWrapper);
